import React from "react";

import { hex2rgba } from "../../Helpers/parse";
import ShareButton from "../Buttons/ShareButton";
import copy from 'copy-to-clipboard';
import { GlobalContext } from "../../Context/GlobalContext";

import ScheduleItem from "./ScheduleItem";

const DAY = 86400000
const HOUR = 3600000

let Schedule = ({
  id,
  schedule,
  schedule_info,
  schedule_metadata,
  color,
  setFile,
  visible,
  webScheduleLive,
  webSchedulePrimary,
  webScheduleSecondary,
  webScheduleAvailable,
}) => {
  const { darkMode } = React.useContext(GlobalContext);
  let [state, setState] = React.useState({
    date: new Date(),
    dates: [],
    start: 0,
    end: 7,
  });
  const mountedRef = React.useRef(null);
  let [copied, setCopied] = React.useState(false);
  let [embedCopy, setEmbedCopy] = React.useState(false);

  React.useEffect(() => {
    const parse_dates = async () => {
      let dates = [];
      let currentDate;
      let startDate = schedule_info["start time"];
      let endDate = schedule_info["end time"];
      let loopTime = new Date(startDate).getTime();

      console.log('loop', loopTime);
      
      // If endTime does not end at the start/end of a day,
      // then some schedule items may end up cut off, so we need to compensate for that.
      let endTime = new Date(endDate).getTime()
      let endHour = new Date(endDate).getHours()
      if(endHour > 0) {
        let hourDiff = 24 - endHour
        endTime += hourDiff * HOUR
      }
      while (loopTime < endTime) {
        dates.push(new Date(loopTime));
        if (
          new Date(loopTime).toLocaleString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }) ===
          new Date().toLocaleString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        ) {
          currentDate = new Date(loopTime);
        }
        loopTime += DAY;
      }
      if(dates && dates.length && !currentDate) {
        if(Date.now() < dates[0].getTime()) {
          currentDate = new Date(dates[0].getTime());
        } else {
          currentDate = new Date(dates[dates.length - 1].getTime());
        }
      }
      if (dates && mountedRef.current) {
        setState((state) => ({...state, dates, date: currentDate }));
      }
    };
    if(visible && schedule_info) {
      parse_dates();
    }
  }, [schedule_info, visible]);

  if (visible && schedule) {
    // Here we are editing the url by replacing "video" with the info needed to point to our embed schedule url
    let embedScheduleURL = window.location.href.replace("/video/", "/embed/schedule/");
    let videoId = id

    const embedSchedule = () => {
      let embed = `
      <iframe
        src="${embedScheduleURL}&embedID=${videoId}"
                            allowtransparency="true"
                            frameborder="0"
                            width="720rem"
                            height="500rem"
                            sandbox="allow-same-origin allow-forms allow-scripts allow-popups allow-popups-to-escape-sandbox"
                            scrolling="auto"
                            allowfullscreen
                            style="border:none;border-radius:4px;"
                            id="${
                              videoId
                            }"
                            onload="AdjustIframeHeightOnLoad('${
                              videoId
                            }')"
      >
      </iframe>`
      copy(embed)
      setEmbedCopy(true)
    }

    const getUrlAndCopy = () => {
      copy(embedScheduleURL)
      setCopied(true);
    }

    let ShareScheduleProps = {
      buttonText: "SHARE SCHEDULE",
      color: color,
      copied: copied,
      embedCopy: embedCopy,
      onCopyUrlClick: getUrlAndCopy,  
      onEmbedVideoClick: embedSchedule,
      copyUrlToolTip: "Copy Schedule URL",
      copyUrlToolTipPlacement: "top",
      embedToolTip: "Embed Schedule",
      embedToolTipPlacement: "top",
    }

    let schedule_item = schedule
      .filter((item) => {
        return item.item;
      })
      .map((item) => {
        try {
          let announce = item.guid ? schedule_metadata[item.guid]["schedule announce"] : undefined
          if (
            new Date(item.start).toLocaleString("en-US", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }) ===
              state.date.toLocaleString("en-US", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              }) &&
            // Always show if announce is 1, or yes, or true
            ((announce && (announce === 1 || announce === true || announce === "1" || announce === "yes" || announce === "true")) ||
            // If item is not default and announce is not explicitly set to 0, no, or false
            (!item.default && announce !== false && announce !== 0 && announce !== "no" && announce !== "0" && announce !== "false"))
          ) {
            return (
              <ScheduleItem
                key={`${item.guid}${item.start}${item.end}`}
                item={item}
                color={color}
                schedule_metadata={schedule_metadata}
                setFile={setFile}
                webScheduleLive={webScheduleLive}
                webSchedulePrimary={webSchedulePrimary}
                webScheduleSecondary={webScheduleSecondary}
                webScheduleAvailable={webScheduleAvailable}
              />
            );
          } else {
            return ""
          }
        } catch (e) {
          return "";
        }
      });
    let schedule_dates = state.dates.map((item) => {
      return (
        <div className="col " key={item}>
          <div
            onClick={() => {
              setState({ ...state, date: item });
            }}
            className="text-center sched-day"
            style={{
              color:
                state.date.toLocaleString("en-US", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }) ===
                item.toLocaleString("en-US", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
                  ? webSchedulePrimary
                    ? webSchedulePrimary
                    : color
                  : "",
              backgroundColor:
                state.date.toLocaleString("en-US", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }) ===
                item.toLocaleString("en-US", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
                  ? color
                    ? webSchedulePrimary
                      ? hex2rgba(webSchedulePrimary, 0.08)
                      : hex2rgba(color, 0.08)
                    : ""
                  : "",
              borderColor:
                state.date.toLocaleString("en-US", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }) ===
                item.toLocaleString("en-US", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
                  ? color
                    ? webSchedulePrimary
                      ? hex2rgba(webSchedulePrimary, 0.4)
                      : hex2rgba(color, 0.4)
                    : ""
                  : "transparent",
              cursor: "pointer",
            }}
          >
            <div>
              <strong>
                {item.toLocaleString("en-US", {
                  weekday: "short",
                })}
              </strong>
            </div>
            <div>
              {item.toLocaleString("en-US", {
                day: "2-digit",
              })}
            </div>
          </div>
        </div>
      );
    });
    return (
      <>
      <div className="mt-3 flex-row flex-half" ref={mountedRef}>
        <ShareButton {...ShareScheduleProps}/>
      </div>
      <div className="schedule-body mt-3">
        <ul className="list-group" style={{ backgroundColor: darkMode ? '#FFFFFF' : '', borderRadius: '4px' }}>
          <li
            className="list-group-item"
            style={{
              padding: 0,
              overflow: "hidden",
              backgroundColor: webScheduleSecondary
                ? hex2rgba(webScheduleSecondary, 0.08)
                : "",
              borderColor: webScheduleSecondary
                ? hex2rgba(webScheduleSecondary, 0.4)
                : "",
              color: webScheduleSecondary ? webScheduleSecondary : "#000000",
            }}
          >
            <div className="row">
              <div
                className="col-1 text-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  let previousDate = new Date(state.date.getTime() - DAY)
                  if(previousDate.getDate() !== state.dates[0].getDate() && previousDate.getTime() < state.dates[0].getTime()) {
                    return
                  }
                  let {start, end} = state
                  while(previousDate.getDate() !== state.dates[start].getDate() && previousDate.getTime() < state.dates[start].getTime()) {
                    start--;
                    end--;
                  }
                  setState((state) => ({...state, date: previousDate, start, end}))
                  // console.log(state.dates.includes(state.dates[1]));
                  /*
                  if (state.date !== state.dates[0]) {
                    let start = state.start;
                    let end = state.end;

                    if (
                      start ===
                      state.dates
                        .map((d) => {
                          return d.getTime();
                        })
                        .indexOf(state.date.getTime())
                    ) {
                      start--;
                      end--;
                    }

                    setState({
                      ...state,
                      date:
                        state.dates[
                          state.dates
                            .map((d) => {
                              return d.getTime();
                            })
                            .indexOf(state.date.getTime()) - 1
                        ],
                      start,
                      end,
                    });
                  }
                  */
                }}
              >
                <i className="fas fa-lg fa-caret-left"></i>
              </div>
              <div
                className="col text-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <strong>
                  {state.date ? state.date.toLocaleString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                    weekday: "long",
                  }) : ""}
                </strong>
              </div>
              <div
                className="col-1 text-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  let nextDate = new Date(state.date.getTime() + DAY)
                  if(nextDate.getDate() !== state.dates[state.dates.length - 1].getDate() && nextDate.getTime() > state.dates[state.dates.length - 1].getTime()) {
                    return
                  }
                  let {start, end} = state
                  while(state.dates[end] && nextDate.getTime() >= state.dates[end].getTime()) {
                    start++;
                    end++;
                  }
                  setState((state) => ({...state, date: nextDate, start, end}))
                  /*
                  if (state.date !== state.dates[state.dates.length - 1]) {
                    let start = state.start;
                    let end = state.end;

                    if (
                      end ===
                      state.dates
                        .map((d) => {
                          return d.getTime();
                        })
                        .indexOf(state.date.getTime()) +
                        1
                    ) {
                      end++;
                      start++;
                    }
                    setState({
                      ...state,
                      date:
                        state.dates[
                          state.dates
                            .map((d) => {
                              return d.getTime();
                            })
                            .indexOf(state.date.getTime()) + 1
                        ],
                      start,
                      end,
                    });
                  }
                  */
                }}
              >
                <i className="fas fa-lg fa-caret-right"></i>
              </div>
            </div>
          </li>
          <li
            className="list-group-item"
            style={{
              padding: 0,
              overflow: "hidden",
              backgroundColor: webScheduleSecondary
                ? hex2rgba(webScheduleSecondary, 0.08)
                : "",
              borderColor: webScheduleSecondary
                ? hex2rgba(webScheduleSecondary, 0.4)
                : "",
              color: webScheduleSecondary ? webScheduleSecondary : "#000000",
            }}
          >
            <div className="row">
              <div
                className="col-1 text-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  if (state.start > 0) {
                    setState({
                      ...state,
                      start: state.start - 1,
                      end: state.end - 1,
                    });
                  }
                }}
              >
                <i className="fas fa-lg fa-caret-left"></i>
              </div>
              {schedule_dates.slice(state.start, state.end)}
              <div
                className="col-1 text-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  if (state.end < state.dates.length) {
                    setState({
                      ...state,
                      start: state.start + 1,
                      end: state.end + 1,
                    });
                  }
                }}
              >
                <i className="fas fa-lg fa-caret-right"></i>
              </div>
            </div>
          </li>
        </ul>
        <ul className="list-group">{schedule_item}</ul>
      </div>
      </>
    );
  } else {
    return <div></div>;
  }
};

export default Schedule
